import { render, staticRenderFns } from "./PicRevisionReport.vue?vue&type=template&id=418a020c&"
import script from "./PicRevisionReport.vue?vue&type=script&lang=js&"
export * from "./PicRevisionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports